import * as React from "react";
const SvgTrailEnd = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 10, viewBox: "0 0 9 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 0L1 18C1 22.4183 4.58172 26 9 26V26", stroke: "#C5C6D0" }));
export default SvgTrailEnd;
